import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 10.375C9 9.06334 10.0633 8 11.375 8H14.25C14.6642 8 15 8.33579 15 8.75C15 9.16421 14.6642 9.5 14.25 9.5H11.375C10.8917 9.5 10.5 9.89174 10.5 10.375C10.5 10.8583 10.8917 11.25 11.375 11.25H12.625C13.9367 11.25 15 12.3133 15 13.625C15 14.9367 13.9367 16 12.625 16H9.75C9.33579 16 9 15.6642 9 15.25C9 14.8358 9.33579 14.5 9.75 14.5H12.625C13.1083 14.5 13.5 14.1083 13.5 13.625C13.5 13.1417 13.1083 12.75 12.625 12.75H11.375C10.0633 12.75 9 11.6867 9 10.375Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7C12.4142 7 12.75 7.33579 12.75 7.75V8.25C12.75 8.66421 12.4142 9 12 9C11.5858 9 11.25 8.66421 11.25 8.25V7.75C11.25 7.33579 11.5858 7 12 7Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15C12.4142 15 12.75 15.3358 12.75 15.75V16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V15.75C11.25 15.3358 11.5858 15 12 15Z"
      fill="currentColor"
    />
  </SvgIcon>
));
